import React from 'react';
import { connect } from 'react-redux';
import { columnName, columnPermissions, columnSelect } from '@/constants/fields';
import paging from '@/hooks/paging';
import RolesTable from '../components/RolesTable';
import { fetchRoles } from '../actions';

const RoleReassignRolesTable = ({
  roles,
  readStatus,
  readErrors,
  total,
  currentPage,
  pageSize,
  pageCount,
  fetchData,
}) => {
  paging.useFetchByCategory(fetchData, 'reassign', readStatus);
  return (
    <RolesTable
      category="reassign"
      className="aridhia-role-reassign-roles-table"
      columns={[columnSelect, columnName, columnPermissions]}
      currentPage={currentPage}
      fetchData={fetchData}
      hideColumns
      hideFlags
      pageCount={pageCount}
      pageSize={pageSize}
      readErrors={readErrors}
      readStatus={readStatus}
      roles={roles}
      total={total}
      selectable
    />
  );
};

const mapStateToProps = ({
  roles: {
    roles: {
      reassign: {
        results, readStatus, readErrors, count, currentPage, pageSize, totalPages,
      },
    },
  },
}) => ({
  currentPage,
  pageCount: totalPages,
  pageSize,
  readStatus,
  readErrors,
  roles: results,
  total: count,
});

const mapDispatchToProps = {
  fetchData: fetchRoles,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleReassignRolesTable);
